// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1JiU0","footer":"ReportModalFilter_footer__1CvQB"};